import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import { useLoginContext } from "../../Contexts/LoginContext";
import CustomerService from "../../Services/CustomerService";
import { useOrderTypeContext } from "../../Contexts/OrderTypeContext";
import { ImSpinner8 } from "react-icons/im";
import CardProfileOrder from "../../Components/Layout/Profile/CardProfileOrder";
import { useLayoutContext } from "../../Contexts/LayoutContext";
import ButtonLink from "../../Components/Form/ButtonLink";
import { TbMoodConfuzed } from "react-icons/tb";
import { isOrderOpen } from "../../Utils/Helpers";
import ProfileTitle from "./ProfileTitle";
import { useOrderHook } from "../../Hooks/OrderHook";
import { useTranslation } from "react-i18next";

const ProfileOrders = () => {
    
    const { t } = useTranslation();
    const { currentStore } = useStoreContext();
    const { user } = useLoginContext();
    const { orderType } = useOrderTypeContext();
    const [ loadingOrders, setLoadingOrders ] = useState(false);
    const [ ordersList, setOrdersList ] = useState<[]>([]);
    const { isMobile } = useLayoutContext();
    const { getOrderDetail, goToOrderView } = useOrderHook();

    document.title = t('profile.orders.title');

    const getOrders = async () => {
        setLoadingOrders(true);
        const payload = {
            user_id: user.id,
        }
        try {
            const customerService = new CustomerService(orderType);
            const response = await customerService.getCustomerOrders(payload);
            if (response.data) {
                setOrdersList(response.data);
            }
        setLoadingOrders(false);
        } catch (error: any) {
            setLoadingOrders(false);
        }
    }

    useEffect(() => {
        getOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleGetDetail = (order: any) => {
        if (isOrderOpen(order)) {
            goToOrderView((order.id));
        } else {
            getOrderDetail(order.id);
        }
    }

    return (
        <>
            <DefaultLayout showHeader={currentStore}>
                <DefaultLayoutProfile>
                    <div className="flex flex-col gap-2 p-2 pt-0">

                        <ProfileTitle>
                            <span>{t('profile.orders.title')}</span>
                            <ButtonLink rounded={isMobile} onClick={() => getOrders()} disabled={loadingOrders} className={'text-sm gap-1 md:w-28'}>
                                <span><ImSpinner8 className={`${loadingOrders && 'animate-spin'}`} /></span>
                                {!isMobile && <span>{loadingOrders ? t('profile.orders.button_refresh_loading') : t('profile.orders.button_refresh_label')}</span>}
                            </ButtonLink>
                        </ProfileTitle>

                        {loadingOrders && (
                            <div className="flex items-center gap-1 text-gray-500"><ImSpinner8 className="animate-spin" /><span>{t('layout.loading')}</span></div>
                        )}

                        {!loadingOrders && (
                            Array.isArray(ordersList) && ordersList.length > 0 ? (
                                <div className="grid text-sm divide-y rounded-none divide-gray-100 transition-all ease-in-out">
                                    {ordersList.map((order: any, index: number) => (
                                        <CardProfileOrder order={order} onClick={() => handleGetDetail(order)} key={order.id ?? index} />
                                    ))}
                                </div>
                            ) : <div className="flex items-center gap-1 text-gray-500"><TbMoodConfuzed /><span>{t('profile.orders.no_orders_found')}</span></div>
                        )}

                    </div>
                </DefaultLayoutProfile>
            </DefaultLayout>
        </>
    );
};

export default ProfileOrders;